/**
 * Returns an inline style object for the hero CTA card based on the CTA config.
 * Shared between HeroBackground and HeroOverlay.
 *
 * @param {object} ctaConfig - The CTA configuration from heroConfig.cta
 * @returns {object} Style object
 */
export const getCardStyle = (ctaConfig) => {
    const style = {};
    if (ctaConfig?.card?.backgroundColor) style.backgroundColor = ctaConfig.card.backgroundColor;
    if (ctaConfig?.card?.border) style.border = ctaConfig.card.border;
    if (ctaConfig?.card?.backdropFilter) style.backdropFilter = ctaConfig.card.backdropFilter;
    if (ctaConfig?.card?.boxShadow) style.boxShadow = ctaConfig.card.boxShadow;
    return style;
};
